import { dFix } from '@/data/utils/floatingPoint';
import {
	getItemPartNumber,
	getProductPrice,
	getProductQuantity,
} from 'presentation/events/utils/productUtils';
import { Categories } from 'shared/custom/hooks/Categories';
import { findParentCategories } from 'shared/custom/utils/getCategoryByIdForGA';

import { TrackViewItemProduct } from './types';

export const calculateProductsValue = (
	products: TrackViewItemProduct[],
	physicalStoreId: string
): number =>
	dFix(
		products.reduce((total, product) => {
			const quantity = getProductQuantity({ quantity: product.quantity });
			const { price } = getProductPrice({ product, quantity, physicalStoreId });
			return total + price * quantity;
		}, 0),
		2
	);

export const getProductCategoryString = (
	product: TrackViewItemProduct,
	navigation: Categories[]
): string => findParentCategories(navigation, product.parentCatalogGroupID).join(' > ');

export const getProductCategoryArray = (
	product: TrackViewItemProduct,
	navigation: Categories[]
): string[] => findParentCategories(navigation, product.parentCatalogGroupID);

export type ViewItemProductData = {
	id: string;
	quantity: number;
	price: number;
	categoryString: string;
};

export const getViewItemProductData = (
	product: TrackViewItemProduct,
	physicalStoreId: string,
	navigation: Categories[]
): ViewItemProductData => {
	const quantity = getProductQuantity({ quantity: product.quantity });
	const { price } = getProductPrice({ product, quantity, physicalStoreId });
	return {
		id: getItemPartNumber(product),
		quantity,
		price,
		categoryString: getProductCategoryString(product, navigation),
	};
};
